export default __webpack_public_path__ + "static/media/24H_Brown.b11c879a.png";